export * from './layout.module';
export * from './tick-tock.module';
export * from './order-details.module';
export * from './cart.module';
export * from './register-form.module';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/modules/index.ts